exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal-dialog.modal-lg {\n  width: 80%; }\n  .modal-dialog.modal-lg .modal-body iframe {\n    height: 80vh; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/buyer/license/license.component.scss
// module id = 493
// module chunks = 0